__turbopack_context__.v({
  "btn": "_3FRq-W_btn",
  "btn--block": "_3FRq-W_btn--block",
  "btn--filled": "_3FRq-W_btn--filled",
  "btn--filled-inverse": "_3FRq-W_btn--filled-inverse",
  "btn--filled-subtle": "_3FRq-W_btn--filled-subtle",
  "btn--ghost": "_3FRq-W_btn--ghost",
  "btn--l": "_3FRq-W_btn--l",
  "btn--m": "_3FRq-W_btn--m",
  "btn--outlined": "_3FRq-W_btn--outlined",
  "btn--rounded": "_3FRq-W_btn--rounded",
  "btn--s": "_3FRq-W_btn--s",
  "icon": "_3FRq-W_icon",
});
